<template>
  <div class="common-article-box" @click="goPage">
    <template v-if="item.comment && item.comment.length">
      <div class="desc">
        {{ deleteHtmlStr(item.comment[0].content) }}
      </div>
      <div class="article-title">
        <font class="re">Re：</font>
        <span class="content">{{ deleteHtmlStr(item.title) }}</span>
      </div>
    </template>
    <template v-else>
      <div class="article-title" v-html="xss(item.title)"></div>
      <div class="desc" v-html="xss(handleSummary(item.summary))"></div>
    </template>
    <div class="user-line">
      <span class="user" v-if="item.comment && item.comment.length">
        <img v-lazy="handleImgSize(item.comment[0].user && item.comment[0].user.avatar, 'mini')" alt="" />
        <span class="name">{{ item.comment[0].user && item.comment[0].user.username }}</span>
      </span>
      <span class="user" v-else>
        <img v-lazy="handleImgSize(item.user.avatar, 'mini')" alt="" />
        <span class="name">{{ item.user.username }}</span>
      </span>
      <div class="info"><i class="iconfont icon-pinglun" /> {{ item.comment_count }}</div>
    </div>
    <div class="bottom-info" v-if="item.thumb || (item.type == 4 && isShowTag(item.tag))">
      <div class="left">
        <div v-if="item.type == 4 && isShowTag(item.tag)" class="type">#{{ tagInfos[item.tag] }}</div>
      </div>
      <div class="right">
        <div class="item" v-if="item.thumb">
          <i class="iconfont icon-tupian1"></i>
          <!-- <span>{{ item.thumb ? '+' + item.thumb.split(',').length : '' }}</span> -->
        </div>
        <!-- <div class="item" v-if="item.video">
          <i class="iconfont icon-shipin"></i>
          <span>{{ item.video && item.video.split(',').length }}</span>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { getJumpWikiDetailUrl } from "@/plugins/util";
export default {
  name: "commonArticle",
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tagInfos: {
        3: "工会",
        4: "交友",
        5: "攻略",
        6: "提问"
      }
    };
  },
  computed: {
    isShowTag() {
      return val => {
        return val == 3 || val == 4 || val == 5 || val == 6;
      };
    }
    // getContentText () {
    //   return (html) => {
    //     let $content = document.createElement('div');
    //     $content.innerHTML = html;
    //     return $content.innerText
    //   };
    // }
  },
  methods: {
    // 服务端渲染，替代getContentText
    deleteHtmlStr(str = "") {
      return str.replace(/<[^>]*>/g, "");
    },
    goPage() {
      const url = getJumpWikiDetailUrl(this.item.game_alias, this.item.game_id, this.item.id, true);
      if (this.isWww) {
        window.open(url);
        return;
      }
      window.location.replace(url);
    },
    handleSummary(text) {
      let str = text;
      if (this.keyword) {
        let reg = new RegExp(`${this.keyword}`, "gim");
        str = text.replace(reg, '<span style="color:red;">' + this.keyword + "</span>");
      }
      return str;
    }
  }
};
</script>
<style lang="less" scoped>
.common-article-box {
  display: block;
  margin-bottom: 15px;
  padding: 10px;
  background-color: rgba(248, 249, 249, 0.66);
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  border-radius: 4px;
  cursor: pointer;
  .article-title {
    display: flex;
    width: 100%;
    cursor: pointer;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    margin-bottom: 8px;
    color: #333;
    font-size: 14px;
    line-height: 20px;
    .re {
      color: #000;
      font-size: 14px;
      font-weight: 600;
    }
    .content {
      text-decoration: underline;
    }
  }
  .desc {
    margin-bottom: 12px;
    color: #999;
    font-size: 12px;
    line-height: 18px;
    overflow: hidden;
  }
  .user-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .user {
      display: flex;
      align-items: center;
      img {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        object-fit: cover;
        margin-right: 8px;
      }
      .name {
        color: #666;
        font-size: 12px;
      }
    }
    .info {
      color: #666;
      font-size: 12px;
    }
  }
  .bottom-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 10px;
    margin-top: 8px;
    border-top: 1px solid #eaeaea;
    .left {
      .type {
        color: #00afe8;
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        padding: 2px 10px;
        border-radius: 4px;
        background-color: rgba(0, 175, 232, 0.1);
      }
    }
    .right {
      display: flex;
      align-items: center;
      .item {
        display: flex;
        align-items: center;
        color: #666;
        span {
          font-size: 12px;
        }
      }
      i {
        // margin-right: 4px;
        font-size: 18px;
      }
    }
  }
}
</style>
